import { Base } from './Base';

import anime from 'animejs';

export class Parallax extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);
    this.init();
  }

  init() {
    this.setupParallax();
  }

  setupParallax() {
    this.parallaxHandler = this.handleParallax.bind(this);
    this.animeTimeline = anime.timeline({ autoplay: false });

    const properties = {
      targets: this.element,
      easing: 'linear',
      marginTop: [75, -75]
    };

    this.animeTimeline.add(properties);

    window.addEventListener('resize', this.parallaxHandler);
    window.addEventListener('scroll', this.parallaxHandler);

    this.parallaxHandler();
  }

  handleParallax() {
    const bound = this.element.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    if (bound.top < windowHeight && bound.bottom > 0) {
      this.animeTimeline.seek(this.animeTimeline.duration * ( (windowHeight - bound.top) / (windowHeight + bound.height) ).toFixed(3));
    } else {
      if (bound.top >= windowHeight) {
        this.animeTimeline.seek(0);
      } else if (bound.bottom <= 0) {
        this.animeTimeline.seek(this.animeTimeline.duration)
      }
    }
  }

  cleanup() {
    window.removeEventListener('resize', this.parallaxHandler);
    window.removeEventListener('scroll', this.parallaxHandler);
  }
}